// custom-date-formatter.ts
import { Injectable } from '@angular/core';
import {
  CalendarDateFormatter,
  DateAdapter,
  DateFormatterParams,
} from 'angular-calendar';
import { DatePipe } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class CustomDateFormatter extends CalendarDateFormatter {
  constructor(private datePipe: DatePipe, dateAdapter: DateAdapter) {
    super(dateAdapter); // Aquí pasamos dateAdapter al constructor de la clase base
  }

  // Personaliza los encabezados de los días para usar la abreviación de 3 letras
  public override monthViewColumnHeader({
    date,
    locale,
  }: DateFormatterParams): string {
    return this.datePipe.transform(date, 'EEE', locale) ?? ''; // 'EEE' para abreviaturas de 3 letras
  }
}
